import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider, Grid, List, ListItem, ListItemText, CircularProgress } from '@mui/material';
import { endLoading, startLoading } from '../../../Redux/loadingSlice';
import { UrlConstant } from '../../../commom/UrlConstant';
import Axios from '../../../config/axios';
import moment from 'moment';
import { usePriceFormatter } from '../../../hooks';
import { useAppDispatch } from '../../../Redux/hooks';

const Loaninfo: React.FC<any> = ({ stockDetail, loanAmountData, stockQty, decimals }: any) => {
  const formatter = usePriceFormatter();
  const currentPrice = stockDetail?.quote?.USD?.price ?? 0;
  const loanQty = currentPrice > 0 ? Number(loanAmountData?.offer?.offerPrice) / currentPrice : 0;

  // const dispatch = useAppDispatch();
  // const [loanInfo, setLoanInfo] = useState<any>();
  // const [installmentsList, setInstallmentsList] = useState<any>([]);
  // const [loading, setLoading] = useState<boolean>(false); // Loading state


  // const fetchLoanInfo = async () => {
  //   setLoading(true); // Start loading
  //   dispatch(startLoading());
  //   const symbol = stockDetail?.symbol;
  //   const stockPrice = loanAmountData?.offer?.offerPrice;
  //   try {
  //     const response = await Axios.get(
  //       UrlConstant.BoosterLoan.GetLoanDetails.replace("{0}", symbol).replace("{1}", stockPrice)
  //     );

  //     setLoanInfo(response.data?.data);
  //     const installments = response.data?.data?.installments?.map((item) => ({
  //       date: moment(item.dueDate).format("DD-MMM-YYYY"),
  //       amount: item.amount,
  //     }));
  //     setInstallmentsList(installments);
  //   } catch (error: any) {
  //     console.error("ERRR : ", error);
  //   } finally {
  //     dispatch(endLoading());
  //     setLoading(false); // End loading
  //   }
  // };

  // useEffect(() => {
  //   fetchLoanInfo();
  // }, []);

  return (
    <Box sx={{ margin: '0 auto', color: '#fff' }}>
      {/* Loading Spinner */}
      {/* {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress sx={{ color: '#f2674a' }} />
        </Box>
      ) : ( */}
      {/* <> */}
      {/* Price Section */}
      {/* <Grid container sx={{ textAlign: 'center', justifyContent: 'space-between', padding: 3 }}>
            <Grid item>
              <Typography variant="body1" className="text-secondary">Ask Price</Typography>
              <Typography variant="h5">$18.90</Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" className="text-secondary">Bid Price</Typography>
              <Typography variant="h5">$18.90</Typography>
            </Grid>
          </Grid> */}

      <Divider sx={{ borderColor: '#FFFFFF70', marginY: 1 }} />

      {/* Loan Information */}
      <Box sx={{ paddingY: 1, padding: 3 }}>
        <Box display="flex" justifyContent="space-between" marginBottom={1}>
          <Typography variant="body1" className="text-secondary">Loan Amount</Typography>
          <Typography variant="body1">{formatter.display(loanAmountData?.offer?.offerPrice)}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" marginBottom={1}>
          <Typography variant="body1" className="text-secondary">Qty.</Typography>
          <Typography variant="body1">{formatter.quantity(loanQty).display}</Typography>
        </Box>
        {(() => {
          const percentage = loanAmountData?.offer?.originationFeePercentageAmount;
          const dollar = loanAmountData?.offer?.originationFeeDollar;

          // prefer percentage only if it's > 0
          const fee = Number(percentage) > 0 ? percentage : dollar;

          return Number(fee) > 0 ? (
            <Box display="flex" justifyContent="space-between" marginBottom={1}>
              <Typography variant="body1" className="text-secondary">
                Origination Fee
              </Typography>
              <Typography className="text-white" variant="body1">
                {formatter.amount(Number(fee)).display}
              </Typography>
            </Box>
          ) : null;
        })()}

        {loanAmountData?.offer?.serviceCharge === 'apr_percentage' &&
          <Box display="flex" justifyContent="space-between" marginBottom={1}>
            <Typography variant="body1" className="text-secondary">Interest(APR)</Typography>
            <Typography variant="body1">{loanAmountData?.offer?.serviceInterest || 0}%</Typography>
          </Box>
        }
        {loanAmountData?.offer?.serviceCharge === 'apr_percentage' ?
          <Box display="flex" justifyContent="space-between" marginBottom={1}>
            <Typography variant="body1" className="text-secondary">Interest Amount</Typography>
            <Typography variant="body1">{formatter.amount(loanAmountData?.offer?.serviceInterestAmount).display}</Typography>
          </Box>
          : <Box display="flex" justifyContent="space-between" marginBottom={1}>
            <Typography variant="body1" className="text-secondary">Service Fees Amount</Typography>
            <Typography variant="body1">{formatter.amount(loanAmountData?.offer?.serviceFee).display}</Typography>
          </Box>
        }
        <Box display="flex" justifyContent="space-between" marginBottom={1} sx={{ fontWeight: 'bold' }}>
          <Typography variant="body1" className="text-secondary">Total Loan Amount</Typography>
          <Typography variant="body1">{formatter.amount(loanAmountData?.offer?.totalAmount).display}</Typography>
        </Box>
      </Box>

      <Divider sx={{ borderColor: '#FFFFFF70', marginY: 1 }} />

      {/* Loan Installments */}
      <Box padding={3}>
        <Typography variant="h6" className="text-secondary" gutterBottom>
          Loan Installments
        </Typography>
        <List dense>
          {loanAmountData?.installments.length > 0 ? (
            loanAmountData?.installments.map((item, index) => (
              <ListItem key={index} sx={{ paddingY: 0.5 }}>
                <ListItemText
                  primary={`${index + 1}. ${moment(item.dueDate).format('DD - MMM - YYYY')}`}
                  primaryTypographyProps={{ variant: 'body1' }}
                />
                <Typography variant="body1">{formatter.amount(item.totalAmount).display}</Typography>
              </ListItem>
            ))
          ) : (
            <Typography variant="body1" color="textSecondary">
              No installments available.
            </Typography>
          )}
        </List>
      </Box>
      {/* </> */}
      {/* )} */}
    </Box>
  );
};

export default Loaninfo;
